import { all } from 'redux-saga/effects';
import apiSaga from './api/saga';
import authSaga from './auth/saga';
import mapSaga from './map/saga';
import audioSaga from './audio/saga';

export default function* rootSaga(getState: any): any {
    yield all([
        apiSaga(),
        authSaga(),
        mapSaga(),
        audioSaga(),
    ]);
}